<template>
    <div class="home_swiper_wrapper">
        <div class="swiper">
            <swiper :options="swiperOption">
                <swiper-slide>
                    <img src="../../assets/media/default.jpg" alt />
                </swiper-slide>
                <!-- <swiper-slide>
                    <img src="../../assets/media/gtl.jpg" alt />
                </swiper-slide> -->
                <swiper-slide>
                    <img src="../../assets/media/gf.jpg" alt />
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeSwiper',
    props: {
        swiperList: Array,
    },
    data() {
        return {
            swiperOption: {
                pagination: '.home_swiper_wrapper .swiper-pagination',
                paginationClickable: true,
                grabCursor: true,
                loop: true,
                autoplay: 5000,
                autoplayDisableOnInteraction: false,
                coverflow: {
                    rotate: 30,
                    stretch: 10,
                    depth: 60,
                    modifier: 2,
                    slideShadows: true,
                },
            },
        }
    },
    computed: {
        showSwiper() {
            return this.swiperList.length
        },
    },
    mounted() {
        this.isLoading = false
    },
}
</script>

<style lang="scss" scoped>
.swiper::v-deep .swiper-container {
    z-index: 0 !important;
}

.swiper::v-deep .swiper-pagination-bullet-active {
    background: #f29a32 !important;
    transition: background 0.9s;
}

.swiper::v-deep .swiper-pagination-bullet {
    width: 27px;
    height: 27px;
    opacity: 1;
    margin-left: 36px !important;
    box-sizing: border-box;
    border: 2px solid #f29a32;
    border-radius: 100%;
    background: none;
    cursor: pointer;
}
.swiper::v-deep .swiper-pagination-bullets {
    bottom: 67px;
}

.home_swiper_wrapper {
    width: 100%;
    height: 960px;
}

.swiper {
    position: relative;
    z-index: 0;
    width: 100%;
    height: 0;
    padding-bottom: 52.083333%;
    background: #ccc;
    .swiper-container {
        width: 1920px;
        height: 960px;
        position: absolute;
        left: 50%;
        margin-left: -960px;
    }
}
</style>
